var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { COLOR } from "../utils/variables";
import "./index.scss";
var RadioButton = function (props) {
    var containerStyle = {
        padding: 2,
        margin: 3,
        fontSize: 15,
        fontWeight: 500,
    };
    var buttonStyle = {
        border: "1px solid ".concat(COLOR.GRAY),
        color: COLOR.BLACK,
        padding: 5,
        margin: ".5%",
        display: "inline-block",
        borderRadius: 3,
        width: "49%",
        background: COLOR.WHITE,
        minHeight: 40,
        cursor: props.disabled ? "not-allowed" : "pointer",
    };
    var errorMsgStyle = {
        color: COLOR.RED,
        fontSize: 13,
        paddingLeft: 3,
    };
    return (React.createElement("div", { style: containerStyle },
        React.createElement("div", { className: "label-wrapper" },
            props.label &&
                React.createElement("div", { className: "label" }, props.label),
            !props.isRequired && React.createElement("span", { className: "form-optional" }, "Optional"),
            props.tooltipLabel &&
                React.createElement("div", { className: "form-tooltip" },
                    React.createElement("span", { className: "form-tooltiptext form-tooltip-right" }, props.tooltipLabel))),
        React.createElement("div", null, props.buttonList.map(function (item, index) {
            var inputStyle = buttonStyle;
            if (item.value === props.value) {
                inputStyle = __assign(__assign({}, buttonStyle), { background: props.activeColor ? props.activeColor : COLOR.PRIMARY, color: COLOR.WHITE });
            }
            return (React.createElement("button", { style: inputStyle, disabled: props.disabled, key: index, type: "button", onClick: function () { return props.onChangeHandler(props.fieldName, item.value, props.index); } },
                item.iconUrl &&
                    React.createElement("div", null,
                        React.createElement("img", { src: item.iconUrl, alt: "icon", width: "30", height: "30" })),
                item.name));
        })),
        props.errorMsg &&
            React.createElement("div", { style: errorMsgStyle }, props.errorMsg)));
};
RadioButton.defaultProps = {
    isRequired: true
};
export default RadioButton;
//# sourceMappingURL=index.js.map